/**
 * Procurement sidebar badge store.
 * Written by `<ProcurementBadgeSubscriber />`; read by `procurementsMenu`.
 */

import { create } from 'zustand';

interface ProcurementBadgesState {
  pendingApprovals: number;
  myRequestsInFlight: number;
  setFromMetrics: (m: Partial<Pick<ProcurementBadgesState, 'pendingApprovals' | 'myRequestsInFlight'>>) => void;
  applyDelta: (m: Partial<Pick<ProcurementBadgesState, 'pendingApprovals' | 'myRequestsInFlight'>>) => void;
  reset: () => void;
}

const EMPTY = { pendingApprovals: 0, myRequestsInFlight: 0 };
const clamp = (n: number) => (n < 0 ? 0 : n);

export const useProcurementBadgesStore = create<ProcurementBadgesState>((set) => ({
  ...EMPTY,
  setFromMetrics: (m) =>
    set({
      pendingApprovals: clamp(m.pendingApprovals ?? 0),
      myRequestsInFlight: clamp(m.myRequestsInFlight ?? 0),
    }),
  applyDelta: (m) =>
    set((state) => ({
      pendingApprovals: clamp(state.pendingApprovals + (m.pendingApprovals ?? 0)),
      myRequestsInFlight: clamp(state.myRequestsInFlight + (m.myRequestsInFlight ?? 0)),
    })),
  reset: () => set(EMPTY),
}));
